import * as types from "../redux/constants/index";

/* 
    this function handles errors being returned from the server.
    the server uses express-validator which returns errors as arrays
    of objects. any custom errors will also be sent as arrays of 
    objects for continuity
*/
const handler = (error, dispatch) => {
    const errorsArray = error.response?.data.errors;
    const errorType = error.response?.data.type;

    if(errorsArray){
        dispatch({
            type: errorType,
            payload: errorsArray
        })

        return
    }

    // if(errorType){
    //     dispatch({
    //         type: errorType,
    //         payload: error.response.data.message,
    //     })

    //     return
    // }
}

export default handler;